import React from 'react';
import { motion } from 'framer-motion';
import { TimecodeNotes } from '../components/TimecodeNotes';

export const TimecodeNotesPage: React.FC = () => {
  return (
    <div className="w-full min-h-screen">
      {/* Themed Header Section */}
      <motion.div 
        className="text-center mb-8"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h1 className="text-4xl sm:text-5xl font-bold mb-4 bg-gradient-to-r from-sky-400 via-blue-400 to-indigo-400 bg-clip-text text-transparent">
          Timecode Notes
        </h1>
        <p className="text-gray-300 max-w-3xl mx-auto leading-relaxed">
          Professional timecode-synchronized note-taking tool for film editors and supervisors. 
          Capture precise timestamps during review sessions with frame-accurate timing.
        </p>
        <div className="mt-4 text-sm text-sky-200/70">
          <p>Frame-accurate timing • Export to CSV • Project management</p>
        </div>
      </motion.div>
      
      <TimecodeNotes />
    </div>
  );
};

export default TimecodeNotesPage;
